<template>
  <div>
    <div class="help_Info_right fr">
      <div class="help_Info_right_top fl">退换货细则</div>
      <div class="help_Info_right_bootm shoppstep fl">
        <dl>
          <dt>1、判断实际收货日期规则：西始配送上门订单、合作物流配送订单，均以物流反馈客户实际签收日期为准。</dt>
        </dl>
        <dl>
          <dt>2、客户寄回商品时需要在包装里附有如下书面内容：</dt>
          <dd>1) 受理单号、客户联系人及联系方式；</dd>
          <dd>2) 需退/换/修的商品订货号、型号、数量、退货原因。</dd>
        </dl>
        <dl>
          <dt>3、退换货需提供证明材料：</dt>
          <dd>1) 整个包裹图片、发货清单图片、产品外包装图片和产品细节图片；</dd>
          <dd>2) 为保障准确性，并提高退换货效率，证明材料不能涂画、挤压。</dd>
        </dl>
        <dl>
          <dt>4、运费承担：</dt>
          <dd>1) 由西始引起的退换货，运费由西始承担；</dd>
          <dd>2) 其他原因引起的退换货，运费由客户承担。</dd>
        </dl>
        <dl>
          <dt>5、退换货期：如果出现商品错发需要退换货的，经确认核实后，在收到客户退回货物后将第一时间处理客户补发或退款事宜。</dt>
        </dl>
        <dl>
          <dt>6、关于发票：</dt>
          <dd>1) 如果增值税发票已开具，客户尚未抵扣，须退还增值税发票；</dd>
          <dd>2) 如果已经抵扣，请提供《开具红字增值税专用发票申请单》；</dd>
          <dd>3) 如以上不能提供，客户需承担由此产生的税金损失, 即发票含税金额的13%。</dd>
        </dl>
        <dl>
          <dt>7、退换货注意事项：</dt>
          <dd>1、 退货的同时必须退回相应的发票和相关文件。如果增值税发票已开具，不能提供增值税发票原件或《开具红字增值税专用发票申请单》，您需支付所退产品不含税价的16%作为"退货操作费"；如需要退款给个人账户，您需要提供盖公章的退款证明。发票请于一个月内退回，逾期客户需承担由此产生的税金损失, 即发票含税金额的13%。</dd>
          <dd>2、 经西始确认符合换货政策的产品可以接受A换A或A换B（B可以是多个不同SKU的产品或多个数量的同一SKU产品)。如更换的产品金额高于原产品金额，您需先将剩余货款汇至西始账户。如更换产品金额低于原产品金额，西始可将多余货款退还至您的指定账户，您也可以选择不退款，作为货款支付其他订单。</dd>
          <dd>3、 请对寄回的产品妥善包装，如包裹内部发出碰撞声或小件物品零散置于包裹中，请您务必放入足够的填充物，您可以重新使用西始发货时的包装材料。请注意快递单不能直接粘贴在产品原包装上，否则会影响再次销售而造成不能退换货。</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "rule"
};
</script>

<style>
</style>
